<template>
    <body :class="{ debug: isDev, update: isUpdate }">
    <header>

        <b-navbar toggleable="md" type="light" variant="light" id="top-bar">
            <b-navbar-brand to="/">
                <img src="/static/images/logo-sphere-h53.png" alt="">
                Service App
            </b-navbar-brand>

            <template v-if="user">
                <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

                <b-collapse is-nav id="nav_collapse">

                    <b-navbar-nav>
                        <b-nav-item to="/" exact>Home</b-nav-item>
                        <b-nav-item to="/clients" exact>Clients</b-nav-item>
                        <b-nav-item to="/fund" exact>Fund</b-nav-item>
                        <b-nav-item to="/rebalance" exact>Rebalance</b-nav-item>
                        <b-nav-item to="/prices" exact>Prices</b-nav-item>
                        <b-nav-item to="/currencies" exact>Currencies</b-nav-item>
                    </b-navbar-nav>

                    <b-navbar-nav class="ml-auto">
                        <b-nav-item-dropdown text="Settings" right>
                            <b-dropdown-item to="/groups">Groups</b-dropdown-item>
                            <b-dropdown-item to="/users">Users</b-dropdown-item>
                        </b-nav-item-dropdown>
                        <b-nav-item-dropdown :text="user.name" right>
                            <b-dropdown-item to="/change">Change Password</b-dropdown-item>
                        </b-nav-item-dropdown>
                        <b-nav-item @click="logout">Logout</b-nav-item>
                    </b-navbar-nav>

                </b-collapse>
            </template>

        </b-navbar>

    </header>

    <router-view></router-view>

    <footer class="text-center">
        <img src="/static/images/logo-horizontal-h53.png" alt="Blockchain.bg">
    </footer>

    <div v-if="isDev && (user && (user.email === 'dimitar.velev17@gmail.com' || user.email === 'tsvetan@tsvetan.com' || user.email === 'mutarodelev@gmail.com'))" id="dev-toolbox">
        <b-btn v-b-toggle.collapseDevToolbox variant="outline-danger">* Dev Toolbox</b-btn>
        <b-collapse id="collapseDevToolbox" class="mt-2">
            <b-card>
                <button type="button" class="btn btn-success btn-sm" @click="exportAllTransactions">Export Transactions
                </button>
                <button v-if="isDev" type="button" class="btn btn-danger btn-sm" @click="deleteAllTransactions">Delete All
                    Transactions
                </button>
                <div slot="footer">
                    {{ buildTimestamp }}
                </div>
            </b-card>
        </b-collapse>
    </div>

    </body>
</template>

<script>
  import moment from 'moment'
  import Papa from 'papaparse'
  import FileSaver from 'file-saver'
  export default {
    data() {
      return {
        i18n: {
          lang: this.$t('lang'),
        },
        isDev: process.env.APP_DEBUG,
        isUpdate: process.env.APP_UPDATE,
        buildTimestamp: process.env.BUILD_TIMESTAMP,
      }
    },
    methods: {
      logout() {
        this.$store.dispatch('logout')
      },
      deleteAllTransactions() {
        if (window.confirm('Are you sure you want to delete all transactions?')) {
          this.$store.dispatch('deleteAllTransactions')
            .then(() => {
              window.location.reload(true)
              window.alert('All transactions are deleted successfully.')
            })
        }
      },
      generateCSV(data) {
        // let transactionId = parseFloat(this.transactionId) || 0
        // const date = this.customFormatter(this.date)
        const rows = [
          ['Date', 'Counterparty', 'Client ID', 'Portfolio ID', 'Transaction ID', 'Type', 'Currency 1 Amount', 'Currency 1', 'Currency 2 Amount', 'Currency 2', 'Value in BGN'],
        ]
        // Fees
        for (let tx of data) {
          rows.push([
            this.customFormatter(tx.date),
            `${tx.counterparty.user.firstName} ${tx.counterparty.user.lastName}`,
            tx.counterparty.user.clientId,
            tx.portfolioId,
            tx.transactionId,
            tx.type,
            tx.currency1Amount,
            tx.currency1,
            tx.currency2Amount,
            tx.currency2,
            tx.bgnAmount,
          ])
          // tx.details.pricesPieces.forEach((el, i) => {
          //   rows.push([
          //     date,
          //     `${client.firstName} ${client.lastName}`,
          //     client.clientId,
          //     client.portfolios[0].id,
          //     transactionId++,
          //     'blockchain fee',
          //     this.customFixed(client.details.blockchainFees[i], 14),
          //     this.tableValues[i + 1].baseAsset,
          //     '',
          //     '',
          //   ])
          // })
          //
          // client.details.pricesPieces.forEach((el, i) => {
          //   rows.push([
          //     date,
          //     `${client.firstName} ${client.lastName}`,
          //     client.clientId,
          //     client.portfolios[0].id,
          //     transactionId++,
          //     'change',
          //     this.customFixed(client.details.ccy1Arr[i], 14),
          //     this.tableValues[i + 1].baseAsset,
          //     this.customFixed(client.details.ccy2Arr[i], 14),
          //     this.tableValues[0].baseAsset,
          //   ])
          // })
        }
        // console.log(rows)
        return !data ? rows : Papa.unparse(rows, {delimiter: ','})
      },
      exportAllTransactions() {
        this.$store.dispatch('exportAllTransactions')
          .then(res => {
            FileSaver.saveAs(
              new Blob([this.generateCSV(res)], {type: 'text/csv;charset=utf-8'}),
              `All-Transactions-${this.customFormatter(this.date)}.csv`
            )
          })
      },
      customFixed(str, num = 8) {
        const rgx = new RegExp(`-?\\d+\\.?\\d{0,${num}}`)
        str = (`${str}`).match(rgx)
        return str ? parseFloat(str[0]).toFixed(num) : parseFloat(0).toFixed(num)
      },
      customFormatter(date) {
        return moment(date).format('DD.MM.YYYY')
      },
    },
    computed: {
      user() {
        return this.$store.getters.getLoggedUser
      },
    },
    watch: {
      '$i18n.locale': function() {
        this.i18n.lang = this.$t('lang')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/-service-app/App.vue